// ============================================================================
// v4 — shared UI kit so every screen uses one consistent system + palette.
// ============================================================================
import React from 'react';
import { Spark } from './viz';
import metaLogo from 'static/icons/hub/meta.svg';

// rounded-square chip with the real platform logo inside (all demo campaigns are Meta)
export function ChannelIcon() {
  return (
    <span className="v4-chan">
      <img src={metaLogo} alt="Meta" />
    </span>
  );
}

export const fmt$ = (n) => '$' + Math.round(n).toLocaleString('en-US');
export const fmt$2 = (n) => '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const fmtK = (n) => (n >= 1000000 ? '$' + (n / 1000000).toFixed(2) + 'M' : n >= 1000 ? '$' + Math.round(n / 1000) + 'k' : '$' + Math.round(n));
export const fmtN = (n) => Math.round(n).toLocaleString('en-US');
export const fmtX = (n) => n.toFixed(2) + 'x';
export const pct = (cur, prev) => (prev > 0 ? ((cur - prev) / prev) * 100 : 0);

export const PALETTE = { violet: '#5A54F3', cyan: '#38bdf8', mint: '#8AE8BD', magenta: '#ec4899', amber: '#fbbf24', rose: '#fb7185', indigo: '#7A75F6' };

export function PageHeader({ title, sub, right, live }) {
  return (
    <header className="v4-top">
      <div>
        <h1>{title}</h1>
        {sub && <p className="v4-sub">{sub}</p>}
      </div>
      <div className="v4-top-right">
        {live && <span className="v4-live"><i /> Live · updated just now</span>}
        {right}
      </div>
    </header>
  );
}

export function DatePill({ children = 'Last 30 days' }) {
  return <button className="v4-pill">{children} ▾</button>;
}

export function Card({ title, sub, right, className = '', children, pad = true }) {
  return (
    <div className={'v4-card ' + className} style={pad ? undefined : { padding: 0 }}>
      {(title || right) && (
        <div className="v4-card-head">
          <div>{title && <h3>{title}</h3>}{sub && <span className="v4-muted">{sub}</span>}</div>
          {right}
        </div>
      )}
      {children}
    </div>
  );
}

export function Delta({ value, invert }) {
  const up = invert ? value <= 0 : value >= 0;
  return (
    <span className={'v4-delta ' + (up ? 'up' : 'down')}>
      {value >= 0 ? '▲' : '▼'} {Math.abs(value).toFixed(1)}%
    </span>
  );
}

export function StatCard({ label, value, delta, deltaInvert, live, color = '#5A54F3', valueColor, series, vs = 'vs prev 30d' }) {
  return (
    <div className="v4-kpi">
      <div className="v4-kpi-head">
        <span className="v4-kpi-label">{label}</span>
        {live && <span className="v4-badge">LIVE</span>}
      </div>
      <div className="v4-kpi-value" style={valueColor ? { color: valueColor } : undefined}>{value}</div>
      {delta !== undefined && (
        <div className="v4-kpi-foot"><Delta value={delta} invert={deltaInvert} /><span className="v4-kpi-vs">{vs}</span></div>
      )}
      {series && <div className="v4-kpi-spark"><Spark data={series} color={color} w={150} h={38} /></div>}
    </div>
  );
}

export function Pill({ tone = 'mid', children }) {
  return <b className={'pill ' + tone}>{children}</b>;
}

export function Insight({ title = 'AI Insight', children, link = 'View full analysis →' }) {
  return (
    <div className="v4-card v4-ai">
      <div className="v4-ai-head"><span className="v4-spark-ico">✦</span> {title}</div>
      <p>{children}</p>
      {link && <a className="v4-ai-link">{link}</a>}
    </div>
  );
}

// tone helpers
export const roasTone = (r) => (r >= 4.5 ? 'good' : r >= 2.5 ? 'mid' : 'low');
export const toneColor = (t) => (t === 'good' ? PALETTE.mint : t === 'mid' ? PALETTE.cyan : PALETTE.amber);
